import { Routes, Route } from "react-router-dom";
import Inicio from "./Components/Inicio/Inicio";
import Trajes from "./Components/Trajes/Trajes";
import Smokings from "./Components/Smokings/Smokings";
import "./index.css";
import Negros from "./Components/Trajes/Negros/Negros";
import Azules from "./Components/Trajes/Azules/Azules";
import Italo from "./Components/Trajes/Negros/Italo";
import ItaloSmk from "./Components/Smokings/SmokingsNegros/ItaloSmk";
import Tarento from "./Components/Smokings/SmokingsNegros/Tarento";
import Mexico from "./Components/Trajes/Negros/Mexico";
import Pingpong from "./Components/Trajes/Negros/Pingpong";
import Snegros from "./Components/Smokings/SmokingsNegros/Snegros";
import Collar from "./Components/Smokings/SmokingsNegros/Collar";
import Manhattan from "./Components/Smokings/SmokingsNegros/Manhattan";
import Munich from "./Components/Smokings/SmokingsNegros/Munich";
import Berlin from "./Components/Smokings/SmokingsNegros/Berlin";
import Sazules from "./Components/Smokings/SmokingsAzules/Sazules";
import Marino from "./Components/Trajes/Azules/Marino";
import Italia from "./Components/Trajes/Azules/Italia";
import Francia from "./Components/Trajes/Azules/Francia";
import Genova from "./Components/Trajes/Azules/Genova";
import Napoles from "./Components/Trajes/Azules/Napoles";
import TorinoAzul from "./Components/Smokings/SmokingsAzules/TorinoAzul";
import Grises from "./Components/Trajes/Grises/Grises";
import Tintos from "./Components/Trajes/Tintos/Tintos";
import Sgrises from "./Components/Smokings/SmokingsGrises/Sgrises";
import Stintos from "./Components/Smokings/SmokingsTintos/Stintos";
import Togas from "./Components/Togas/Togas";
import Doradas from "./Components/Togas/Doradas/Doradas";
import Tintas from "./Components/Togas/Tintas/Tintas";
import Tazules from "./Components/Togas/Azules/Tazules";
import Londres from "./Components/Smokings/SmokingsGrises/Londres";
import Sverdes from "./Components/Smokings/SmokingsVerdes/Sverdes";
import Colores from "./Components/Trajes/Colores/Colores";
import Sterling from "./Components/Trajes/Grises/Sterling";
import Amsterdam from "./Components/Trajes/Grises/Amsterdam";
import Salvatore from "./Components/Trajes/Grises/Salvatore";
import Zuricht from "./Components/Trajes/Grises/Zuricht";
import Torinot from "./Components/Trajes/Tintos/Torinot";
import Tunez from "./Components/Trajes/Tintos/Tunez";
import Barcelona from "./Components/Trajes/Colores/Barcelona";
import Praga from "./Components/Trajes/Colores/Praga";
import Tokio from "./Components/Smokings/SmokingsTintos/Tokio";
import Milan from "./Components/Smokings/SmokingsTintos/Milan";
import Budapest from "./Components/Smokings/SmokingsAzules/Budapest";
import Paris from "./Components/Smokings/SmokingsAzules/Paris";
import Zurichs from "./Components/Smokings/SmokingsGrises/Zurichs";
import Bulgaria from "./Components/Smokings/SmokingsVerdes/Bulgaria";
import ScrollToTop from "./Components/ScrollToTop";
import Catalogot from "./Components/CatalogoTrajes/Catalogot";
import Catalogoto from "./Components/CatalogoTrajes/Catalogoto";
import Cambridge from "./Components/Trajes/Colores/Cambridge";
import Manchester from "./Components/Trajes/Grises/Manchester";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Inicio />}/>
        <Route path="/catalogo-trajes" element={<Catalogot />}/>
        <Route path="/catalogo-togas" element={<Catalogoto />}/>

        {/*---------------- TRAJES -----------------------*/}

        <Route path="/trajes" element={<Trajes />}/>
        
        {/*---------------- TRAJES NEGROS-----------------------*/}

        <Route path="/trajes/negros" element={<Negros />}/>
        <Route path="/trajes/negros/italo" element={<Italo />}/>
        <Route path="/trajes/negros/pingpong" element={<Pingpong />}/>
        <Route path="/trajes/negros/mexico" element={<Mexico />}/>

        {/*---------------- TRAJES AZULES-----------------------*/}

        <Route path="/trajes/azules" element={<Azules />}/>
        <Route path="/trajes/azules/marino" element={<Marino />}/>
        <Route path="/trajes/azules/italia" element={<Italia />}/>
        <Route path="/trajes/azules/francia" element={<Francia />}/>
        <Route path="/trajes/azules/genova" element={<Genova />}/>
        <Route path="/trajes/azules/napoles" element={<Napoles />}/>

      {/*---------------- TRAJES GRISES-----------------------*/}

        <Route path="/trajes/grises" element={<Grises />}/>
        <Route path="/trajes/grises/sterling" element={<Sterling />}/>
        <Route path="/trajes/grises/amsterdam" element={<Amsterdam />}/>
        <Route path="/trajes/grises/salvatore" element={<Salvatore />}/>
        <Route path="/trajes/grises/zuricht" element={<Zuricht />}/>
        <Route path="/trajes/grises/manchester" element={<Manchester />}/>

      {/*---------------- TRAJES TINTOS-----------------------*/}

        <Route path="/trajes/tintos" element={<Tintos />}/>
        <Route path="/trajes/tintos/torino-tinto" element={<Torinot />}/>
        <Route path="/trajes/tintos/tunez" element={<Tunez />}/>

      {/*---------------- TRAJES COLORES-----------------------*/}
        <Route path="/trajes/colores" element={<Colores />}/>
        <Route path="/trajes/colores/barcelona" element={<Barcelona />}/>
        <Route path="/trajes/colores/praga" element={<Praga />}/>
        <Route path="/trajes/colores/cambridge-linen" element={<Cambridge />}/>

      {/*---------------- SMOKINGS -----------------------*/}
        <Route path="/smokings" element={<Smokings />}/>

      
      {/*---------------- SMOKINGS NEGROS -----------------------*/}

        <Route path="/smokings/negros" element={<Snegros />}/>
        <Route path="/smokings/negros/italo-smk" element={<ItaloSmk />}/>
        <Route path="/smokings/negros/tarento" element={<Tarento />}/>
        <Route path="/smokings/negros/collar" element={<Collar />}/>
        <Route path="/smokings/negros/manhattan" element={<Manhattan />}/>
        <Route path="/smokings/negros/munich" element={<Munich />}/>
        <Route path="/smokings/negros/berlin" element={<Berlin />}/>

      {/*---------------- SMOKINGS AZULES-----------------------*/}

        <Route path="/smokings/azules" element={<Sazules />}/>
        <Route path="/smokings/azules/torinoazul" element={<TorinoAzul />}/>
        <Route path="/smokings/azules/budapest" element={<Budapest />}/>
        <Route path="/smokings/azules/paris" element={<Paris />}/>

      {/*---------------- SMOKINGS GRISES-----------------------*/}
        <Route path="/smokings/grises" element={<Sgrises />}/>
        <Route path="/smokings/grises/londres" element={<Londres />}/>
        <Route path="/smokings/grises/zurichs" element={<Zurichs />}/>


      {/*---------------- SMOKINGS TINTOS-----------------------*/}
        <Route path="/smokings/tintos" element={<Stintos />}/>
        <Route path="/smokings/tintos/tokio" element={<Tokio />}/>
        <Route path="/smokings/tintos/milan" element={<Milan />}/>

      {/*---------------- SMOKINGS VERDES-----------------------*/}
        <Route path="/smokings/verdes" element={<Sverdes />}/>
        <Route path="/smokings/verdes/bulgaria" element={<Bulgaria />}/>

      {/*---------------- TOGAS-----------------------*/}
        <Route path="/togas" element={<Togas />}/>

        <Route path="/togas/doradas" element={<Doradas />}/>
        <Route path="/togas/tintas" element={<Tintas />}/>
        <Route path="/togas/azules" element={<Tazules />}/>
      </Routes>
    </>
  );
}

export default App;
